import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
/*Laravel*/
import { environment } from '@env/environment';
import { HttpServiceUtil } from './http-service-util';
import { ToastrService } from 'ngx-toastr';
import { AuthSessionService } from '@services/auth-session.service';
import { Observable } from 'rxjs';

@Injectable()
export class CrudService {
  public url = environment.urlToApi;
  public setMenu = new EventEmitter();

  constructor(
    private _http: HttpClient,
    public toastr: ToastrService,
    private authSession: AuthSessionService
  ) { }

  file(route, data): Observable<Blob> {
    const headers = this.authSession.buildHeaders();

    return this._http.post(this.url + route, data, { headers, responseType: 'blob' });
  }

  getData(route) {
    const httpOptions = HttpServiceUtil.setHeaders(this.authSession);
    return this._http.get<any>(this.url + route, httpOptions);
  }

  get = (route) => new Promise((resolve, reject) => {
    this._http.get(this.url + route, HttpServiceUtil.setHeaders(this.authSession))
      .subscribe(res => {
        resolve(res);
      }, (rej: any) => {
        HttpServiceUtil.errorHandling(rej, this.toastr);
        reject(rej);
      });
  })

  delete = (route) => new Promise((resolve, reject) => {
    this.disableButtons();
    this._http.delete(this.url + route, HttpServiceUtil.setHeaders(this.authSession))
      .subscribe(res => {
        resolve(res);
        this.enableButtons();
      }, (rej: any) => {
        HttpServiceUtil.errorHandling(rej, this.toastr);
        reject(rej);
        this.enableButtons();
      });
  })

  post = async (route: string, data: any) => {
    try {
      this.disableButtons();
      const res = await this._http.post(this.url + route, data, HttpServiceUtil.setHeaders(this.authSession)).toPromise();
      this.enableButtons();
      return res;
    } catch (error) {
      this.enableButtons();
      if (error.status === 403) {
        throw { status: 'ERRO', message: 'Não autorizado.' };
      }
      HttpServiceUtil.errorHandling(error, this.toastr);
      throw error;
    }
  };


  patch = (route, data) => new Promise((resolve, reject) => {
    this.disableButtons();
    this._http.patch(this.url + route, data, HttpServiceUtil.setHeaders(this.authSession))
      .subscribe(res => {
        resolve(res);
        this.enableButtons();
      }, (rej: any) => {
        if (rej.status == 403) { reject({ 'status': 'ERRO', 'message': 'Não autorizado.' }); }
        {
          HttpServiceUtil.errorHandling(rej, this.toastr);
          reject(rej);
          this.enableButtons();
        }
      });
  })

  put = (route, data) => new Promise((resolve, reject) => {
    this.disableButtons();
    this._http.put(this.url + route, data, HttpServiceUtil.setHeaders(this.authSession))
      .subscribe(res => {
        resolve(res);
        this.enableButtons();
      }, (rej: any) => {
        HttpServiceUtil.errorHandling(rej, this.toastr);
        reject(rej);
        this.enableButtons();
      });
  })

  disableButtons() {
    if (document.getElementById('applyBtn')) { document.getElementById('applyBtn').setAttribute('disabled', 'disabled'); }
    if (document.getElementById('modalApplyBtn')) { document.getElementById('modalApplyBtn').setAttribute('disabled', 'disabled'); }
  }

  enableButtons() {
    if (document.getElementById('applyBtn')) { document.getElementById('applyBtn').removeAttribute('disabled'); }
    if (document.getElementById('modalApplyBtn')) { document.getElementById('modalApplyBtn').removeAttribute('disabled'); }
  }

  downloadFileFromUrl = (filePath, filename) => new Promise((resolve, reject) => {
    const headers = this.authSession.buildHeaders({
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    this._http.get(this.url + 'public/download?filePath=' + filePath + '&filename=' + filename, { headers, responseType: 'blob' })
      .subscribe(response => {

        resolve(response);
      }, rej => {
        HttpServiceUtil.errorHandling(rej, this.toastr);
        reject(rej);
      });
  })

  postToCompressFile = (route, data) => new Promise((resolve, reject) => {
    const headers = this.authSession.buildHeaders();

    this.disableButtons();
    this._http.post(this.url + route, data, { headers, responseType: 'blob' })
      .subscribe(res => {
        resolve(res);
        this.enableButtons();
      }, (rej) => {
        if (rej.status == 403) { reject({ 'status': 'ERRO', 'message': 'Não autorizado.' }); }
        {
          HttpServiceUtil.errorHandling(rej, this.toastr);
          reject(rej);
          this.enableButtons();
        }
      });
  })
}
